// src/hooks/useProfesoresCandidatos.ts
import { useQuery } from "@tanstack/react-query";
import api from "../api/axios";

export interface ProfesorCandidato {
  id: number;
  nombre: string;
}

export function useProfesoresCandidatos(idAsignatura: number | "") {
  return useQuery<ProfesorCandidato[]>({
    queryKey: ["profesores-candidatos", idAsignatura],
    enabled: !!idAsignatura,
    queryFn: async () => {
      const { data } = await api.get(`/formaciones/candidatos/${idAsignatura}`);
      return data;
    },
  });
}
